import React from 'react'
import PropTypes from 'prop-types'
import { font } from '../constants/font'
import Typography from '../common-components/Typography'
import { MainWrap } from './publish-component'

const Exceed = ({ content = '', showExceed = false }) => {
    if (!showExceed) return null

    return (
        <MainWrap>
            <Typography
                content={content}
                font={font.normalMini_12}
                className="isExceed"
                color="#6E5000"
            />
        </MainWrap>
    )
}

Exceed.propTypes = {
    content: PropTypes.string,
    showExceed: PropTypes.bool,
}

export default Exceed
